import gsap from 'gsap';

export const addPrevNextBtnHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => emblaApi.scrollPrev();
  const scrollNext = () => emblaApi.scrollNext();
  prevBtn.addEventListener('click', scrollPrev, false);
  nextBtn.addEventListener('click', scrollNext, false);

  return () => {
    prevBtn.removeEventListener('click', scrollPrev, false);
    nextBtn.removeEventListener('click', scrollNext, false);
  };
};

const calculateTweenValuesOpacity = (emblaApi, minOpacity, tweenFactor) => {
  const engine = emblaApi.internalEngine();
  const scrollProgress = emblaApi.scrollProgress();

  return emblaApi.scrollSnapList().map((scrollSnap, index) => {
    if (!emblaApi.slidesInView().includes(index)) return 0;
    let diffToTarget = scrollSnap - scrollProgress;

    if (engine.options.loop) {
      engine.slideLooper.loopPoints.forEach((loopItem) => {
        const target = loopItem.target();
        if (index === loopItem.index && target !== 0) {
          const sign = Math.sign(target);
          if (sign === -1) diffToTarget = scrollSnap - (1 + scrollProgress);
          if (sign === 1) diffToTarget = scrollSnap + (1 - scrollProgress);
        }
      });
    }
    const tweenValue = 1 - Math.abs(diffToTarget * tweenFactor);
    return gsap.utils.clamp(minOpacity, 1, tweenValue);
  });
};

export const setupTweenOpacity = (
  emblaApi,
  minOpacity = 0.4,
  tweenFactor = 3
) => {
  const tweenNodes = emblaApi.slideNodes();

  const applyTweenOpacity = () => {
    const tweenValues = calculateTweenValuesOpacity(
      emblaApi,
      minOpacity,
      tweenFactor
    );
    tweenValues.forEach((tweenValue, index) => {
      tweenNodes[index].style.opacity = tweenValue.toString();
    });
  };

  const removeTweenOpacity = () => {
    tweenNodes.forEach((slide) => slide.removeAttribute('style'));
  };

  return {
    applyTweenOpacity,
    removeTweenOpacity
  };
};
